import { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";
import { Layers, PackageOpen, Star, MapPin } from "lucide-react";

const CountUp = ({ target, suffix = "", duration = 1400 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target, duration]);

  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
};

const STATS = [
  { icon: Layers, type: "count", target: 7, label: "Kategori Layanan", sub: "CCTV, WiFi, Parabola, Komputer, Network, POS, Kursus" },
  { icon: PackageOpen, type: "count", target: 30, suffix: "+", label: "Produk & Paket", sub: "Pilihan paket lengkap dengan harga transparan" },
  { icon: Star, type: "text", value: "5.0", label: "Rating Google", sub: "dari 3 ulasan pelanggan" },
  { icon: MapPin, type: "text", value: "Lebak", label: "Area Layanan", sub: "Rangkasbitung, Lebak & sekitarnya" },
];

export const Stats = () => (
  <section className="relative overflow-hidden bg-[#071A33] py-16 md:py-20">
    <div className="absolute inset-0 opacity-60 [background:radial-gradient(50%_60%_at_20%_0%,rgba(11,99,246,0.35),transparent_60%),radial-gradient(40%_60%_at_90%_100%,rgba(22,199,232,0.25),transparent_60%)]" />
    <div className="relative max-w-7xl mx-auto px-5 md:px-10">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="text-center lg:text-left lg:border-l lg:border-white/10 lg:pl-6"
          >
            <s.icon className="h-6 w-6 text-[#16C7E8] mx-auto lg:mx-0" />
            <div className="mt-3 font-heading font-extrabold text-4xl md:text-5xl bg-gradient-to-r from-white to-[#16C7E8] bg-clip-text text-transparent">
              {s.type === "count" ? <CountUp target={s.target} suffix={s.suffix} /> : s.value}
            </div>
            <p className="mt-2 font-semibold text-white text-sm md:text-base">{s.label}</p>
            <p className="mt-1 text-xs text-white/55 leading-relaxed">{s.sub}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
